'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationConstants = require('../../../common/validation/validationConstants');

/**
 * Returns an error object if the field config has a max length and the field's value is longer than the max length.
 * Otherwise returns null.
 */
exports.default = function (fieldValue, validationConfig) {
    // If there's no maxlength validation, or the field's length is less than the max length, don't return an error
    if (!validationConfig.maxLength || validationConfig.maxLength >= fieldValue.length) return null;

    return {
        name: _validationConstants.FAILURE_NAMES.maxlength,
        type: _validationConstants.FAILURE_TYPES.ERROR,
        debounced: true,
        message: 'Must be less than ' + validationConfig.maxLength + ' characters'
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/maxLengthValidator.js
// module id = 2300
// module chunks = 0